import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 160px;
`;

export const LoaderWrapper = styled.div`
  padding-top: 160px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 605px;
`;

export const Title = styled.h1`
  display: block;
  font-family: Poppins-Regular, sans-serif;
  font-size: 31px;
  font-weight: normal;
  margin: 20px 0;
  text-align: center;
`;

export const TitleIcon = styled.img`
  margin-right: 10px;
`;

export const Description = styled.div`
  font-family: Poppins-Regular, sans-serif;
  font-size: 16px;
  text-align: center;
  color: #777e90;
  max-width: 525px;
`;
